import { canViewRefunds } from '../global_context/capabilities/refundCapabilities'
import {
  canViewPosAnalysisDownload,
  canViewPosEffectiveness,
  canViewPosTasks
} from '../global_context/capabilities/posCapabilities'
import {
  canViewRbacRoles,
  canViewRbacUsers
} from '../global_context/capabilities/rbacManagementCapabilities'
import {
  canViewClientApplications,
  canViewClients
} from '../global_context/capabilities/clientCapabilities'
import { canViewProducts } from '../global_context/capabilities/productCapabilities'
import { canViewSegments } from '../global_context/capabilities/segmentCapabilities'
import { canViewEssentials } from '../global_context/capabilities/essentialCapabilities'
import {
  canViewPriceLists,
  canViewSpecialPrices
} from '../global_context/capabilities/priceCapabilities'
import { canViewPromotions } from '../global_context/capabilities/promoCapabilities'
import { canViewUsersApp } from '../global_context/capabilities/userAppCapabilities'
import { canViewRoutePlans } from '../global_context/capabilities/routePlanCapabilities'
import {
  canViewPocFillRate,
  canViewPocOrders,
  canViewPocStoreRelations
} from '../global_context/capabilities/pocCapabilities'
import {
  canViewAssignDeliveries,
  canViewDeliveries
} from '../global_context/capabilities/deliveryCapabilities'
import { canViewQuotes } from '../global_context/capabilities/quoteCapabilities'
import { canViewOrders } from '../global_context/capabilities/orderCapabilities'
import { canViewOnBoardSales } from '../global_context/capabilities/onBoardSaleCapabilities'
import { canViewCharges } from '../global_context/capabilities/chargeCapabilities'
import {
  canViewAssetReports,
  canViewCloseAssets
} from '../global_context/capabilities/assetCapabilities'
import { canViewSettlements } from '../global_context/capabilities/settlementCapabilities'
import { canViewReports } from '../global_context/capabilities/reportCapabilities'

/**
 * Ítems navegables del menú lateral (NavBar), aplanados para búsqueda rápida en móvil.
 */
export function getNavSearchItems() {
  return [
    { label: 'Inicio', path: '/inicio', section: null, icon: 'home', visible: true },
    {
      label: 'Listado de clientes',
      path: '/clientes',
      section: 'Planifica',
      group: 'Clientes',
      icon: 'store',
      activeUrls: ['/crear_cliente'],
      visible: canViewClients()
    },
    {
      label: 'Solicitud cliente nuevo',
      path: '/solicitud_cliente_nuevo',
      section: 'Planifica',
      group: 'Clientes',
      icon: 'store',
      activeUrls: ['/crear_solicitud_cliente_nuevo'],
      visible: canViewClientApplications()
    },
    {
      label: 'Productos',
      path: '/productos',
      section: 'Planifica',
      icon: 'work',
      activeUrls: ['/crear_producto'],
      visible: canViewProducts()
    },
    {
      label: 'Segmentos',
      path: '/segmentos',
      section: 'Planifica',
      icon: 'hub',
      visible: canViewSegments()
    },
    {
      label: 'Infaltables',
      path: '/infaltables',
      section: 'Planifica',
      icon: 'shopping_basket',
      activeUrls: ['/asociar_infaltable'],
      visible: canViewEssentials()
    },
    {
      label: 'Listas de Precios',
      path: '/listas_de_precios',
      section: 'Planifica',
      group: 'Precios',
      icon: 'payments',
      activeUrls: ['/crear_lista_de_precios'],
      visible: canViewPriceLists()
    },
    {
      label: 'Precios Especiales',
      path: '/precios_especiales',
      section: 'Planifica',
      group: 'Precios',
      icon: 'payments',
      activeUrls: ['/crear_precio_especial'],
      visible: canViewSpecialPrices()
    },
    {
      label: 'Promociones',
      path: '/promociones',
      section: 'Planifica',
      icon: 'redeem',
      activeUrls: ['/nueva_promo'],
      visible: canViewPromotions()
    },
    {
      label: 'Tareas en PDV',
      path: '/ejecucion_punto_venta',
      section: 'Planifica',
      icon: 'checklist',
      activeUrls: ['/crear_tarea_punto_venta'],
      visible: canViewPosTasks()
    },
    {
      label: 'Usuarios App',
      path: '/usuarios',
      section: 'Planifica',
      icon: 'group',
      activeUrls: ['/crear_usuario_configuracion'],
      visible: canViewUsersApp()
    },
    {
      label: 'Listado de usuarios',
      path: '/configuracion/rbac/asignar',
      section: 'Planifica',
      group: 'Usuarios Torre',
      icon: 'admin_panel_settings',
      visible: canViewRbacUsers()
    },
    {
      label: 'Roles y permisos',
      path: '/configuracion/rbac/roles',
      section: 'Planifica',
      group: 'Usuarios Torre',
      icon: 'admin_panel_settings',
      activeUrls: ['/configuracion/rbac/roles/nuevo'],
      visible: canViewRbacRoles()
    },
    {
      label: 'Plan de visitas',
      path: '/plan_de_visitas',
      section: 'Planifica',
      icon: 'route',
      activeUrls: ['/crear_plan_de_visita'],
      visible: canViewRoutePlans()
    },
    {
      label: 'Asignar relaciones',
      path: '/store_relations',
      section: 'Planifica',
      group: 'POC',
      icon: 'account_tree',
      visible: canViewPocStoreRelations()
    },
    {
      label: 'Asignación de entregas',
      path: '/asignar_entregas',
      section: 'Planifica',
      icon: 'assignment_ind',
      visible: canViewAssignDeliveries()
    },
    {
      label: 'Órdenes de compra',
      path: '/ordenes_oc',
      section: 'Ejecuta',
      icon: 'assignment',
      activeUrls: ['/ordenes_oc_details'],
      visible: canViewPocOrders()
    },
    {
      label: 'Cotizaciones',
      path: '/cotizaciones',
      section: 'Ejecuta',
      icon: 'tag',
      visible: canViewQuotes()
    },
    {
      label: 'Pedidos',
      path: '/pedidos',
      section: 'Ejecuta',
      icon: 'shopping_cart',
      visible: canViewOrders()
    },
    {
      label: 'Devoluciones',
      path: '/devoluciones',
      section: 'Ejecuta',
      icon: 'undo',
      visible: canViewRefunds()
    },
    {
      label: 'Entregas',
      path: '/entregas',
      section: 'Ejecuta',
      icon: 'local_shipping',
      visible: canViewDeliveries()
    },
    {
      label: 'Venta a bordo',
      path: '/ventas_a_bordo',
      section: 'Ejecuta',
      icon: 'electric_moped',
      visible: canViewOnBoardSales()
    },
    {
      label: 'Cobros',
      path: '/cobros',
      section: 'Ejecuta',
      icon: 'paid',
      visible: canViewCharges()
    },
    {
      label: 'Ejecuciones en PDV',
      path: '/efectividad_de_tareas',
      section: 'Ejecuta',
      icon: 'analytics',
      activeUrls: ['/tareas_en_sitio'],
      visible: canViewPosEffectiveness()
    },
    {
      label: 'Reporte de activos',
      path: '/reporte_activos',
      section: 'Ejecuta',
      group: 'Activos',
      icon: 'inventory_2',
      visible: canViewAssetReports()
    },
    {
      label: 'Cierre de activos',
      path: '/cierre_activos',
      section: 'Ejecuta',
      group: 'Activos',
      icon: 'inventory_2',
      visible: canViewCloseAssets()
    },
    {
      label: 'Liquidaciones',
      path: '/liquidaciones',
      section: 'Ejecuta',
      icon: 'currency_exchange',
      visible: canViewSettlements()
    },
    {
      label: 'Fill Rate por cadena',
      path: '/metricas_gerencia',
      section: 'Mide',
      icon: 'finance_mode',
      visible: canViewPocFillRate()
    },
    {
      label: 'Reportes',
      path: '/reportes',
      section: 'Mide',
      icon: 'bar_chart',
      activeUrls: ['/usuario_reportes', '/visitas-no-efectivas'],
      visible: canViewReports()
    },
    {
      label: 'Descarga de reportes',
      path: '/descarga_analisis_pdv',
      section: 'Mide',
      icon: 'download_2',
      visible: canViewPosAnalysisDownload()
    }
  ].filter((item) => item.visible)
}

export function filterNavSearchItems(items, query) {
  const normalizedQuery = query.trim().toLowerCase()
  if (!normalizedQuery) return items

  return items.filter((item) => {
    const haystack = [item.label, item.section, item.group].filter(Boolean).join(' ').toLowerCase()
    return haystack.includes(normalizedQuery)
  })
}
